// eslint-disable-no-unused-vars

import 'styles/layout/_catalogue.scss';

import { TabPanel, TabView } from 'primereact/tabview';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { After2025, Before2025 } from 'features/Catalogue';

function CataloguePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <TabView>
          <TabPanel header="2025" leftIcon="pi pi-calendar mr-2">
            <After2025 />
          </TabPanel>
          <TabPanel header="Trước 2025" leftIcon="pi pi-calendar mr-2">
            <Before2025 />
          </TabPanel>
        </TabView>
      </Layout>
    </LayoutProvider>
  );
}

export default CataloguePage;
